<app-chant-view-details [isViewOnly]="true" [chantDesperanceInput]="chantDesperance"></app-chant-view-details>
